<template>
  <div class="app-body">
    <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="140px"
    >
      <el-form-item prop="ENABLE_TRANSFER_WHEN_END" label="订单结束后调拨：" >
        <el-select v-model="dataForm.ENABLE_TRANSFER_WHEN_END.paramValue" @change="setData('ENABLE_TRANSFER_WHEN_END')">
          <el-option label="允许" value="1"></el-option>
          <el-option label="不允许" value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'params',
  data () {
    return {
      dataForm: {
        ENABLE_TRANSFER_WHEN_END: {}
      }
    }
  },
  activated () {
    this.getData()
  },
  methods: {
    setData(data){
      this.$api2.put('/sys/params', this.dataForm[data]).then(res => {
        this.getData()
        this.$message.success('保存成功')
      })
    },
    getData () {
      this.$api2.get(`/sys/params/page`, { params: { page: 1, limit: 10000 } }).then(res => {
        let tmp = {}
        res.list.forEach(item => {
          tmp[item.paramCode] = item
        })
        this.$set(this, 'dataForm', tmp)
      })
    }
  }
}
</script>

<style scoped>

</style>
